import { ClockingView } from "@/react/components/entityViews/clocking/ClockingView";

export const ClockingPage = () => {
  return (
    <div className="relative flex flex-1 flex-col bg-background w-full min-w-0 min-h-0" id="clocking-page">
      <div className="flex-1 min-h-0">
        <ClockingView />
      </div>
    </div>
  );
};

export default ClockingPage;
